export default {
  name: "Ticket",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M13.17 13.17a4 4 0 1 0 5.66 0 4.1 4.1 0 0 0-5.66 0zm4.24 4.24c-.76.76-2.07.76-2.83 0a2 2 0 1 1 2.83 0zm13.07-6.8-2.1-2.1a1 1 0 0 0-1.09-.22c-1.39.58-2.54-.41-2.86-.73s-1.31-1.46-.73-2.85a.99.99 0 0 0-.22-1.09l-2.08-2.1a2.05 2.05 0 0 0-2.83 0L1.52 18.57a1.98 1.98 0 0 0 0 2.81l2.1 2.1a1 1 0 0 0 1.09.22c1.39-.58 2.54.41 2.85.73.32.32 1.31 1.46.73 2.86-.16.37-.07.8.22 1.09l2.09 2.09c.39.39.9.58 1.41.58s1.02-.2 1.41-.58l17.05-17.05c.38-.38.58-.88.58-1.41s-.19-1.02-.57-1.4zM12.02 29.06l-1.66-1.66a4.74 4.74 0 0 0-1.38-4.38 4.74 4.74 0 0 0-4.38-1.38l-1.67-1.65L19.98 2.94l1.66 1.66a4.74 4.74 0 0 0 1.38 4.38c.99.99 2.61 1.8 4.38 1.38l1.67 1.65-17.05 17.05z",
  },
}
